export class ElementRequiredLinkedStates {
  id: number;//ElementLinkedStateId: number;
  name: string;//ElementName: string;
  uid: string;//
}
